<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-row>
        <v-dialog
            v-model="dialog.value"
            persistent
            :max-width="maxWidth || 280"
        >
          <template v-slot:activator="bub">
            <v-btn :icon="icon"
                   :style="!persistent ? 'top: -5px; margin-left: 10px; margin-right: 10px;' : ''"
                   :disabled="disabled"
                   :color="color"
                   dark
                   v-on="{...on,...bub.on}"
                   v-bind="{...attrs,...bub.attrs}"
            >
              <v-icon v-if="icon" :color="mdiColor || 'error'">
                {{ mdiIcon }}
              </v-icon>
              <span v-else>{{ btnText }}</span>
            </v-btn>
          </template>
          <slot name="body" :dialog="dialog">
            <v-card>
              <v-card-title class="headline">
                {{ message.title }}
              </v-card-title>
              <v-card-text>
                {{ message.message }}
                <slot :setObject="setObject" name="other">

                </slot>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="acceptMethod(getValue())"
                >
                  Подтвердить
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    @click="dialog.value = false"
                >
                  Отменить
                </v-btn>
              </v-card-actions>
            </v-card>
          </slot>

        </v-dialog>
      </v-row>
    </template>
    <span>{{ tooltipMessage || '' }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: String | Object,
    modal: Object,
    tooltipMessage: String,
    mdiIcon: String,
    mdiColor: String,
    accept: Function,
    disabled: Boolean,
    maxWidth: String,
    persistent: Boolean,
    btnText: String,
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dialog: {
      value: false
    }
  }),
  methods: {
    acceptPrivate() {
      this.dialog.value = false
    },
    getValue() {
      this.acceptPrivate()
      return this.value
    },
    setObject(object) {
      console.log(object)
    }
  },
  computed: {
    acceptMethod() {
      return this.accept || this.acceptPrivate
    },
    message() {
      return {
        title: this.modal?.title || '',
        message: this.modal?.message || 'вы точно хотите удалить этот документ ?',
      }
    }
  }
}
</script>

<style>
.dsa {
  margin-left: 5px;
  margin-right: 5px;
}
</style>